import {
    GET_EMPLOEE_MONTHLY_REIMBURSEMENT_STATS_REQUEST,
    GET_EMPLOEE_MONTHLY_REIMBURSEMENT_STATS_SUCCESS,
    GET_EMPLOEE_MONTHLY_REIMBURSEMENT_STATS_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getEmployeeMonthlyReimbursementStatsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMPLOEE_MONTHLY_REIMBURSEMENT_STATS_REQUEST:
            return {
                error: "",
                loading: true,
                data: [],
            };

        case GET_EMPLOEE_MONTHLY_REIMBURSEMENT_STATS_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_EMPLOEE_MONTHLY_REIMBURSEMENT_STATS_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}

export default getEmployeeMonthlyReimbursementStatsReducer;
